import axios from "~/plugins/axios";

export default {
  getCategories() {
    return axios.get("/web_api/v1/category")
      .then((response) => response.data);
  },
  paginate(page = 1, perPage = 15, includes = []) {
    return axios.get("/web_api/v1/category", {
      params: {
        page,
        perPage,
        include: includes,
      },
    })
      .then((response) => response.data);
  },
  getCustomerCategories() {
    return axios.get("/web_api/v1/category/for/customer")
      .then((response) => response.data);
  },

  getNoteCategories(customerId = null, includes = []) {
    return axios.get("/web_api/v1/category/for/note", {
      params: {
        customer_id: customerId,
        include: includes,
      },
    }).then((response) => response.data);
  },
  find(id) {
    return axios.get(`/web_api/v1/category/${id}`).then((response) => response.data);
  },
  getTemplateCategories() {
    return axios.get("/web_api/v1/category/for/template")
      .then((response) => response.data);
  },
};
